function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 4");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, React.createElement("g", {
  id: "29-desktop-UI",
  transform: "translate(-186.000000, -478.000000)",
  fillRule: "nonzero",
  strokeWidth: 2
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(184.805207, 475.710787)"
}, React.createElement("path", {
  d: "M34.0986944,61.1287753 L29.5785434,61.1287753 L29.5785434,44.3643766 L17.8685969,47.4193881 L34.0986944,14.0004296 L49.3414652,47.77148 L37.6315187,44.7164685 L37.6315187,61.1287753 L34.0986944,61.1287753 Z",
  id: "Combined-Shape",
  stroke: "#3F5063",
  strokeLinejoin: "round",
  transform: "translate(33.605031, 37.564602) rotate(-40.000000) translate(-33.605031, -37.564602) "
}), React.createElement("g", {
  id: "Group-2",
  transform: "translate(16.500000, 17.000000) rotate(100.000000) translate(-16.500000, -17.000000) translate(2.000000, 3.000000)",
  stroke: "#6EC18A"
}, React.createElement("path", {
  d: "M14,0 L14,7.79259008",
  id: "Path-14"
}), React.createElement("path", {
  d: "M14,20 L14,27.7925901",
  id: "Path-14-Copy"
}), React.createElement("g", {
  id: "Group",
  transform: "translate(14.500000, 18.500000) rotate(-270.000000) translate(-14.500000, -18.500000) translate(9.500000, 4.500000)"
}, React.createElement("path", {
  d: "M0,0 L0,7.79259008",
  id: "Path-14-Copy-3"
}), React.createElement("path", {
  d: "M0,20 L0,27.7925901",
  id: "Path-14-Copy-2"
}), React.createElement("path", {
  d: "M5,19 L9.72778141,24.2643378",
  id: "Path-14-Copy-4"
})), React.createElement("g", {
  id: "Group-Copy",
  transform: "translate(14.500000, 14.000000) rotate(-225.000000) translate(-14.500000, -14.000000) translate(14.000000, 0.000000)"
}, React.createElement("path", {
  d: "M0,0 L0,7.79259008",
  id: "Path-14-Copy-3"
}), React.createElement("path", {
  d: "M0,20 L0,27.7925901",
  id: "Path-14-Copy-2"
}))))));

var SvgPointer = function SvgPointer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "52px",
    height: "57px",
    viewBox: "0 0 52 57",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPointer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pointer.f8abb573.svg";
export { ForwardRef as ReactComponent };